import React, { useEffect, useState } from 'react'
import ReportTemplates from '../../components/ReportTemplate/ReportTemplate';
import { DropdownItem, DropdownMenu, DropdownToggle, Row, UncontrolledDropdown } from 'reactstrap';
import { useSelector } from 'react-redux';
import { PDFExport } from '@progress/kendo-react-pdf';
import ReportHeader from '../reports/report-header';
import { BsTable } from 'react-icons/bs';
import { exportToTxt, generateExcel } from '../../utils/customFunction';
import html2pdf from "html2pdf.js";

function UnitHolderReport({
    data = ""
}: {
    data?: any
}) {
    const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
    const pdfExportComponent = React.useRef<PDFExport>(null);
    const contentRef = React.useRef(null);
    const ColumnHeading = [
        { label: "Name", value: "Name" },
        { label: "ID", value: "ID" },
        { label: "CNIC", value: "CNIC" },
        { label: "NTN", value: "NTN" },
        { label: "City", value: "City" },
        { label: "Email", value: "Email" },
        { label: "Account No", value: "Account No" },
        { label: "Account Title", value: "Account Title" },
        { label: "Bank Name", value: "Bank Name" },
        { label: "Branch Name", value: "Branch Name" },
        { label: "Filer", value: "Filer" },
        { label: "Tax Exempt", value: "Tax Exempt" },
        { label: "Tax Status", value: "Tax Status" },
        { label: "Zakat Exempt", value: "Zakat Exempt" },
        { label: "Type", value: "Type" },
    ];
    const [ColumnArr, setColumnArr] = useState(ColumnHeading);
    const [selectedValues, setSelectedValues] = useState<any>({
        heading: "",
        sub_heading: "",
        columns: ColumnHeading?.map?.((col) => col?.value),
        balance: ["Opening Balance", "Closing Balance"],
    });
    const [fontSizeVal, setFontSizeVal] = useState<any>(18);
    const [paperSizeVal, setPaperSizeVal] = useState("A4");
    const [layoutVal, setLayoutVal] = useState("Landscape");
    const [marginPDF, setMarginPDF] = useState("1cm");
    const [scalePDF, setScalePDF] = useState(0.5);
    const [screenSizePerPdf, setScreenSizePerPdf] = useState();
    const [dimensionOfPages, setDimensionOfPages] = useState<any>();
    const [itemsToShow, setItemsToShow] = useState(10);
    const [itemsPerPage, setItemsPerPage] = useState<any>(10);

    useEffect(() => {
        const elements = document.querySelectorAll(
            "#test"
        ) as NodeListOf<HTMLElement>;
        elements.forEach((element) => {
            element.style.setProperty("font-size", `${fontSizeVal}px`, "important");
        });
    }, [fontSizeVal, selectedValues]);

    const fixedOrder = [
        'Name',
        'ID',
        'CNIC',
        'NTN',
        'City',
        'Email',
        'Account No',
        'Account Title',
        'Bank Name',
        'Branch Name',
        'Filer',
        'Tax Exempt',
        'Tax Status',
        'Zakat Exempt',
        'Type'
    ];

    const handleDownloadSampleFile = () => {

        const dataSequence = data?.slice(0, itemsToShow)?.map((item) => {
            return {
                Name: item?.name,
                ID: item?.folio_no?.replace("UNITHOLDER_", ""),
                CNIC: item?.cnic,
                NTN: item?.ntn,
                City: item?.city,
                Email: item?.email,
                Account_No: item?.account_no,
                Account_Title: item?.account_title,
                Bank_Name: item?.bank_name,
                Branch_Name: item?.branch_name,
                Filer: item?.filer,
                Tax_Exempt: item?.tax_exempt == "false" || item?.tax_exempt === false ? "No" : "Yes",
                Tax_Status: item?.tax_status,
                Zakat_Exempt: item?.zakat_exempt == "false" || item?.zakat_exempt === false ? "No" : "Yes",
                Type: item?.type
            };
        });

        const reorderColumns = (columns, order) => {
            return order.filter((column) => columns.includes(column));
        };

        const reorderedColumns = reorderColumns(
            selectedValues?.columns,
            fixedOrder
        );

        const ArrayData =
            selectedValues?.columns?.length > 0 &&
            dataSequence?.map((entry) => {
                const result = {};
                reorderedColumns.forEach((column) => {
                    if (column === "Name") {
                        result[column] = entry?.Name;
                    } else if (column === "ID") {
                        result[column] = entry?.ID;
                    } else if (column === "CNIC") {
                        result[column] = entry?.CNIC;
                    } else if (column === "NTN") {
                        result[column] = entry?.NTN;
                    } else if (column === "City") {
                        result[column] = entry?.City;
                    } else if (column === "Email") {
                        result[column] = entry?.Email;
                    } else if (column === "Account No") {
                        result[column] = entry?.Account_No;
                    }
                    else if (column === "Account Title") {
                        result[column] = entry?.Account_Title;
                    }
                    else if (column === "Bank Name") {
                        result[column] = entry?.Bank_Name;
                    }
                    else if (column === "Branch Name") {
                        result[column] = entry?.Branch_Name;
                    }
                    else if (column === "Filer") {
                        result[column] = entry?.Filer;
                    }
                    else if (column === "Tax Exempt") {
                        result[column] = entry?.Tax_Exempt;
                    }
                    else if (column === "Tax Status") {
                        result[column] = entry?.Tax_Status;
                    }
                    else if (column === "Zakat Exempt") {
                        result[column] = entry?.Zakat_Exempt;
                    }
                    else if (column === "Type") {
                        result[column] = entry?.Type;
                    }
                });
                return result;
            });


        generateExcel(
            "Unitholder Statement Report",
            "Unitholder Statement Report",
            "File",
            "File",
            "DCCL",
            [],
            reorderedColumns,
            ArrayData,
            [],
            []
        );
    };

    const handleTXT = () => {
        const dataSequence = data?.slice(0, itemsToShow)?.map((item) => {
            return {
                Name: item?.name,
                ID: item?.folio_no?.replace("UNITHOLDER_", ""),
                CNIC: item?.cnic,
                NTN: item?.ntn,
                City: item?.city,
                Email: item?.email,
                Account_No: item?.account_no,
                Account_Title: item?.account_title,
                Bank_Name: item?.bank_name,
                Branch_Name: item?.branch_name,
                Filer: item?.filer,
                Tax_Exempt: item?.tax_exempt == "false" || item?.tax_exempt === false ? "No" : "Yes",
                Tax_Status: item?.tax_status,
                Zakat_Exempt: item?.zakat_exempt == "false" || item?.zakat_exempt === false ? "No" : "Yes",
                Type: item?.type
            };
        });

        const reorderColumns = (columns, order) => {
            return order.filter((column) => columns.includes(column));
        };

        const reorderedColumns = reorderColumns(
            selectedValues?.columns,
            fixedOrder
        );

        const ArrayData =
            selectedValues?.columns?.length > 0 &&
            dataSequence?.map((entry) => {
                const result = {};
                reorderedColumns.forEach((column) => {
                    if (column === "Name") {
                        result[column] = entry?.Name;
                    } else if (column === "ID") {
                        result[column] = entry?.ID;
                    } else if (column === "CNIC") {
                        result[column] = entry?.CNIC;
                    } else if (column === "NTN") {
                        result[column] = entry?.NTN;
                    } else if (column === "City") {
                        result[column] = entry?.City;
                    } else if (column === "Email") {
                        result[column] = entry?.Email;
                    } else if (column === "Account No") {
                        result[column] = entry?.Account_No;
                    }
                    else if (column === "Account Title") {
                        result[column] = entry?.Account_Title;
                    }
                    else if (column === "Bank Name") {
                        result[column] = entry?.Bank_Name;
                    }
                    else if (column === "Branch Name") {
                        result[column] = entry?.Branch_Name;
                    }
                    else if (column === "Filer") {
                        result[column] = entry?.Filer;
                    }
                    else if (column === "Tax Exempt") {
                        result[column] = entry?.Tax_Exempt;
                    }
                    else if (column === "Tax Status") {
                        result[column] = entry?.Tax_Status;
                    }
                    else if (column === "Zakat Exempt") {
                        result[column] = entry?.Zakat_Exempt;
                    }
                    else if (column === "Type") {
                        result[column] = entry?.Type;
                    }
                });
                return result;
            });

        exportToTxt(
            "",
            selectedValues,
            ArrayData,
            "Unitholder Statement Report"
        );
    };

    const handleGeneratePdf = () => {
        const element = contentRef.current;
        let fileName = "Unitholder-Statement.pdf";
        const options = {
            filename: fileName,
            margin: [10, 3, 10, 3],
            image: { type: "jpeg", quality: 0.95 },
            html2canvas: { scale: 1 },
            jsPDF: {
                unit: "mm",
                format: paperSizeVal || "A4",
                orientation: layoutVal === "Landscape" ? "landscape" : "portrait",
            },
            pagebreak: { mode: ["avoid-all", "css", "legacy"] },
        };
        html2pdf().from(element).set(options).save();
    };

    const handleShowMore = () => {
        setItemsToShow((prev) => prev + itemsPerPage);
    };

    return (
        <div className="mt-0">
            {/* ------------------ Report template starts here ---------- */}
            {data?.length > 0 && (
                <Row>
                    <ReportTemplates
                        ColumnArr={ColumnArr}
                        selectedValues={selectedValues}
                        setSelectedValues={setSelectedValues}
                        pdfExportComponent={pdfExportComponent}
                        setFontSizeVal={setFontSizeVal}
                        fontSizeVal={fontSizeVal}
                        setPaperSizeVal={setPaperSizeVal}
                        paperSizeVal={paperSizeVal}
                        setLayoutVal={setLayoutVal}
                        layoutVal={layoutVal}
                        setScalePDF={setScalePDF}
                        scalePDF={scalePDF}
                        setMarginPDF={setMarginPDF}
                        marginPDF={marginPDF}
                        setScreenSizePerPdf={setScreenSizePerPdf}
                        screenSizePerPdf={screenSizePerPdf}
                        setDimensionOfPages={setDimensionOfPages}
                        contentRef={contentRef}
                        fileName={"Unitholder-Statement.pdf"}
                        printExcel={handleDownloadSampleFile}
                        printTXT={handleTXT}
                        printpdf={handleGeneratePdf}
                    />
                </Row>
            )}
            {/* ------------------ Report template ends here ---------- */}
            <div
                id="printDiv"
                className="p-4"
                style={{
                    // background: "white",
                    color: "black",
                    minWidth: "200px",
                    overflowX: "auto",
                    width: "auto",
                }}
            >
                <div
                    style={{
                        width: `${dimensionOfPages?.find(
                            (item) => item?.key == paperSizeVal
                        )?.dimensions[layoutVal == "Portrait" ? 0 : 1]
                            }`,
                        height: "auto",
                        margin: "0 auto",
                        backgroundColor: "white",
                    }}
                    className="border"
                >
                    <div
                        style={{
                            margin: "0.25in"
                        }}
                        ref={contentRef}>
                        {data?.length > 0 ? (
                            <>
                                <ReportHeader title="Unitholder Statement" />
                                {selectedValues?.columns?.length > 0 ? (
                                    <div>
                                        <>
                                            <div
                                                style={{
                                                    overflowX: "auto",
                                                    overflowY: "hidden",
                                                }}
                                            >
                                                <table
                                                    className="report"
                                                    style={{ color: "black" }}
                                                >
                                                    <thead
                                                        style={{ alignSelf: "center" }}
                                                    >
                                                        <tr>
                                                            {selectedValues?.columns?.map((ele, index) => (
                                                                <th
                                                                    key={index}

                                                                    id="test"
                                                                >
                                                                    {ele}
                                                                </th>
                                                            ))}

                                                        </tr>
                                                    </thead>
                                                    <tbody className="report-table-body">
                                                        {data
                                                            ?.slice(0, itemsToShow)
                                                            ?.map(
                                                                (
                                                                    item: any,
                                                                    index: number
                                                                ) => {
                                                                    return (
                                                                        <>
                                                                            <tr key={index}>
                                                                                {selectedValues?.columns?.includes(
                                                                                    "Name"
                                                                                ) && (
                                                                                        <td
                                                                                            id="test"
                                                                                        >
                                                                                            {item?.name}
                                                                                        </td>
                                                                                    )}
                                                                                {selectedValues?.columns?.includes(
                                                                                    "ID"
                                                                                ) && (
                                                                                        <td
                                                                                            id="test"
                                                                                        >
                                                                                            {item?.folio_no?.replace("UNITHOLDER_", "")}
                                                                                        </td>
                                                                                    )}
                                                                                {selectedValues?.columns?.includes(
                                                                                    "CNIC"
                                                                                ) && (
                                                                                        <td
                                                                                            id="test"
                                                                                        >
                                                                                            {item?.cnic}
                                                                                        </td>
                                                                                    )}
                                                                                {selectedValues?.columns?.includes(
                                                                                    "NTN"
                                                                                ) && (
                                                                                        <td
                                                                                            id="test"
                                                                                        >
                                                                                            {item?.ntn}
                                                                                        </td>
                                                                                    )}
                                                                                {selectedValues?.columns?.includes(
                                                                                    "City"
                                                                                ) && (
                                                                                        <td
                                                                                            id="test"
                                                                                            className="text-right htmltoPdfStyle"
                                                                                        >
                                                                                            {item?.city}
                                                                                        </td>
                                                                                    )}
                                                                                {selectedValues?.columns?.includes(
                                                                                    "Email"
                                                                                ) && (
                                                                                        <td
                                                                                            id="test"
                                                                                            className="text-right htmltoPdfStyle"
                                                                                        >
                                                                                            {item?.email}
                                                                                        </td>
                                                                                    )}
                                                                                {selectedValues?.columns?.includes(
                                                                                    "Account No"
                                                                                ) && (
                                                                                        <td
                                                                                            id="test"
                                                                                            className="text-right htmltoPdfStyle"
                                                                                        >
                                                                                            {item?.account_no}
                                                                                        </td>
                                                                                    )}
                                                                                {selectedValues?.columns?.includes(
                                                                                    "Account Title"
                                                                                ) && (
                                                                                        <td
                                                                                            id="test"
                                                                                            className="text-right htmltoPdfStyle"
                                                                                        >
                                                                                            {item?.account_title}
                                                                                        </td>
                                                                                    )}
                                                                                {selectedValues?.columns?.includes(
                                                                                    "Bank Name"
                                                                                ) && (
                                                                                        <td
                                                                                            id="test"
                                                                                            className="text-right htmltoPdfStyle"
                                                                                        >
                                                                                            {item?.bank_name}
                                                                                        </td>
                                                                                    )}
                                                                                {selectedValues?.columns?.includes(
                                                                                    "Branch Name"
                                                                                ) && (
                                                                                        <td
                                                                                            id="test"
                                                                                            className="text-right htmltoPdfStyle"
                                                                                        >
                                                                                            {item?.branch_name}
                                                                                        </td>
                                                                                    )}
                                                                                {selectedValues?.columns?.includes(
                                                                                    "Filer"
                                                                                ) && (
                                                                                        <td
                                                                                            id="test"
                                                                                            className="text-right htmltoPdfStyle"
                                                                                        >
                                                                                            {item?.filer}
                                                                                        </td>
                                                                                    )}
                                                                                {selectedValues?.columns?.includes(
                                                                                    "Tax Exempt"
                                                                                ) && (
                                                                                        <td
                                                                                            id="test"
                                                                                            className="text-right htmltoPdfStyle"
                                                                                        >
                                                                                            {item?.tax_exempt == "false" || item?.tax_exempt === false ? "No" : "Yes"}
                                                                                        </td>
                                                                                    )}
                                                                                {selectedValues?.columns?.includes(
                                                                                    "Tax Status"
                                                                                ) && (
                                                                                        <td
                                                                                            id="test"
                                                                                            className="text-right htmltoPdfStyle"
                                                                                        >
                                                                                            {item?.tax_status}
                                                                                        </td>
                                                                                    )}
                                                                                {selectedValues?.columns?.includes(
                                                                                    "Zakat Exempt"
                                                                                ) && (
                                                                                        <td
                                                                                            id="test"
                                                                                            className="text-right htmltoPdfStyle"
                                                                                        >
                                                                                            {item?.zakat_exempt == "false" || item?.zakat_exempt === false ? "No" : "Yes"}
                                                                                        </td>
                                                                                    )}
                                                                                {selectedValues?.columns?.includes(
                                                                                    "Type"
                                                                                ) && (
                                                                                        <td
                                                                                            id="test"
                                                                                            className="text-right htmltoPdfStyle"
                                                                                        >
                                                                                            {item?.type}
                                                                                        </td>
                                                                                    )}
                                                                            </tr>
                                                                        </>
                                                                    );
                                                                }
                                                            )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </>
                                    </div>
                                ) : (
                                    <div className="text-center my-5">
                                        <b>No column selected</b>
                                    </div>
                                )}
                            </>
                        ) : (
                            <div className="table-empty">
                                <BsTable className="icon" />
                                <p className="text-center text-primary empty-text">
                                    No record found
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="row align-items-center">
                <div className="col-md-4">
                    {selectedValues?.columns?.length > 0 &&
                        data?.length >= 10 && (
                            <UncontrolledDropdown
                                className="me-2 mt-2"
                                direction="down"
                            >
                                <DropdownToggle
                                    id="TotalRecord_dropdown"
                                    style={{
                                        background: "none",
                                        padding: "0px",
                                        margin: "0px",
                                    }}
                                    className="border"
                                >
                                    <div
                                        id="report_dropdown"
                                        style={{
                                            borderRadius: "4px",
                                            padding: "5px 15px",
                                            color: theme == "light" ? "black" : "white",
                                        }}
                                    >
                                        Per page : {itemsPerPage}
                                    </div>
                                </DropdownToggle>
                                <DropdownMenu
                                    style={{
                                        maxHeight: "300px",
                                        overflow: "auto",
                                        backgroundColor:
                                            theme == "dark" ? "rgb(30, 30, 47)" : "",
                                    }}
                                >
                                    <DropdownItem
                                        className={
                                            itemsPerPage == 10
                                                ? "bg-info text-white"
                                                : ""
                                        }
                                        onClick={() => {
                                            setItemsPerPage(10);
                                            setItemsToShow(10);
                                        }}
                                    >
                                        10
                                    </DropdownItem>
                                    <DropdownItem
                                        className={
                                            itemsPerPage == 25
                                                ? "bg-info text-white"
                                                : ""
                                        }
                                        onClick={() => {
                                            setItemsPerPage(25);
                                            setItemsToShow(25);
                                        }}
                                    >
                                        25
                                    </DropdownItem>
                                    <DropdownItem
                                        className={
                                            itemsPerPage == 50
                                                ? "bg-info text-white"
                                                : ""
                                        }
                                        onClick={() => {
                                            setItemsPerPage(50);
                                            setItemsToShow(50);
                                        }}
                                    >
                                        50
                                    </DropdownItem>
                                    <DropdownItem
                                        className={
                                            itemsPerPage == "All"
                                                ? "bg-info text-white"
                                                : ""
                                        }
                                        onClick={() => {
                                            setItemsPerPage("All");
                                            setItemsToShow(data?.length);
                                        }}
                                    >
                                        All
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        )}
                </div>
                <div className="col-md-4">
                    {itemsToShow < data?.length &&
                        selectedValues?.columns?.length > 0 && (
                            <div className="d-flex justify-content-center my-2">
                                <button
                                    className="btn btn-primary mt-3"
                                    onClick={handleShowMore}
                                >
                                    Show More
                                </button>
                            </div>
                        )}
                </div>
                <div className="col-md-4">
                    {selectedValues?.columns?.length > 0 &&
                        data?.length > 0 && (
                            <div className="d-flex align-items-center justify-content-end">
                                <div
                                    id="TotalRecord_dropdown"
                                    className="border dropdown-toggle btn btn-secondary btn-sm ml-1"
                                    style={{
                                        borderRadius: "4px",
                                        color: theme == "light" ? "black" : "white",
                                        marginTop: "13px",
                                    }}
                                >
                                    Total record :{" "}
                                    {selectedValues?.columns?.length > 0 &&
                                        data?.length > 0
                                        ? data?.length
                                        : 0}
                                </div>
                            </div>
                        )}
                </div>
            </div>
        </div>
    )
}

export default UnitHolderReport